/* eslint-disable class-methods-use-this */
import root from 'window-or-global';
import axios from 'axios';
import Cookies from 'universal-cookie';
import getCountryName from './Country.service';

const URLContactForm = process.env.REACT_APP_CONTACT_FORM_MAIL_TO;
const URLContactSupportForm = process.env.REACT_APP_CONTACT_FORM_SUPPORT_MAIL_TO;
const URLNewsletter = process.env.REACT_APP_NEWSLETTER;
const URLPipedrive = process.env.REACT_APP_PIPEDRIVE;
const SecretKey = process.env.REACT_APP_RECAPTCHA_SECRET_KEY;

class MailingService {
  async sendContactForm({
    firstName, lastName, phone, email, body, url, source, referrer,
  }) {
    return root.fetch(URLContactForm, {
      method: 'POST',
      body: JSON.stringify({
        firstName, lastName, phone, email, body, url, source, referrer,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => (res.ok ? true : Promise.reject(res)));
  }

  async sendNewsletter({ email }) {
    return root.fetch(URLNewsletter, {
      method: 'POST',
      body: JSON.stringify({ email }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => (res.ok ? true : Promise.reject(res)));
  }

  async sendContactSupportForm({
    firstName, lastName, phone, email, body, company, system, osVersion, url, source, referrer,
  }) {
    return root.fetch(URLContactSupportForm, {
      method: 'POST',
      body: JSON.stringify({
        name: `${firstName} ${lastName}`, phone, email, message: body, company, system, osVersion, url, source, referrer,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => (res.ok ? true : Promise.reject(res)));
  }

  async sendPipedrive(data) {
    try {
      const cookies = new Cookies();

      axios.post(URLPipedrive, {
        name: 'jakub.skrzypek@zonifero.com',
        content: data,
        person: {
          name: `${data.firstName} ${data.lastName}`,
          email: data.email,
          phone: data.phone,
          country: getCountryName(data.country)
        },
        marketingAgreement: false,
        inbound: cookies.get('inbound') || 'Inbound - Unidentified',
        businessUnit: 'Zonifero'
      });
      return true;
    } catch (e) {
      return false;
    }
  }

  async spamBotDetected(clientIP, action, token) {
    if (!clientIP) return;
    try {
      const data = {
        clientIP,
        action,
        captchaUrl: (action === 'submit' && token) ? `https://www.google.com/recaptcha/api/siteverify?secret=${SecretKey}&response=${token}` : '',
      }
      const res = await axios.post(process.env.REACT_APP_SECURITY_APP, data);
      if (res.status === 202) return true;
      if (res.status === 200) return false;
    } catch (e) {
      return true;
    }
  }
}

export default new MailingService();



// WEBPACK FOOTER //
// ./src/services/Mailing.service.js